import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  setSelectedTake,
} from "../../app/slices/TrainingSlice";
import usePropHelper from "../../hooks/PropHelper";
import Take3D from "../../models/Take3D";

export function useScenarioBuilderInteractionList(take?: Take3D) {
  const dispatch = useDispatch();
  const { getInvolvedPropInteractions } = usePropHelper();
  const [isInteractionPickerOpen, setIsInteractionPickerOpen] =
    useState(false);

  const openInteractionPicker = () => {
    if (!take) return;

    dispatch(setSelectedTake(take.id));
    getInvolvedPropInteractions(take);
    setIsInteractionPickerOpen(true);
  };

  return {
    isInteractionPickerOpen,
    setIsInteractionPickerOpen,
    openInteractionPicker,
  } as const;
}
